function formDataToQueryString(formData) {
	const params = new URLSearchParams(formData);
	return params.toString();
}

function debounce(func, wait) {
	let timeout;
	return function () {
		clearTimeout(timeout);
		timeout = setTimeout(() => {
			func.apply(this, arguments);
		}, wait);
	};
}

function mainJs() {
	$(document).on("change", "#VariantSelector", function () {
		let newUrl =
			window.location.origin +
			$(this).find("option:selected").data("src");

		window.location = newUrl;
	});

	const gridCarousel = (() => {
		const swiper = new Swiper(".collection-links-grid", {
			// Optional parameters,
			slidesPerView: 2.1,
			spaceBetween: 8,
			breakpoints: {
				768: {
					slidesPerView: 3.1,
					spaceBetween: 12,
				},
				1100: {
					slidesPerView: 6,
					spaceBetween: 16,
				},
			},
		});
	})();

	const single = () => {
		const swiper = new Swiper("#slider-main", {
			// Optional parameters,
			slidesPerView: 1,
			spaceBetween: 0,
			pagination: {
				el: ".c-slider__dots",
				clickable: true,
				type: "bullets",
			},
		});
	};

	$(".colletion-sort-option").on("change", function () {
		var e = $(this).val();
		(Shopify.queryParams.sort_by = e),
			(location.search = new URLSearchParams(
				Shopify.queryParams
			).toString());
	});

	setTimeout(function () {
		if ($(".swym-button.swym-added").length) {
			$(".wishlist").addClass("active");
		} else {
			$(".wishlist").removeClass("active");
		}
	}, 800);

	$(document).on("click", ".swym-button", function () {
		if ($(".swym-button.swym-added").length) {
			$(".wishlist").addClass("active");
		} else {
			$(".wishlist").removeClass("active");
		}
	});

	$(document).on(
		"click",
		".shop-the-look, .shop-the-look-popup__container .close-button",
		function () {
			$(".shop-the-look-popup__container").toggleClass("active");
			$("html").toggleClass("overflow-hidden");
		}
	);

	$(document).on("click", "#shipping-rates-feedback", function () {
		$(".c-delivery-info").toggleClass("active");
		$("#shipping-rates").slideToggle();
	});

	const upsells_swiper = (() => {
		const swiper = new Swiper(".popout-cart-swiper", {
			// Optional parameters
			spaceBetween: 16,
			slidesPerView: "auto",
		});
	})();

	$(document).on(
		"click",
		".js-klaviyo-add, .js-cart-add, .c-cart-counter, .c-quantity-change__button:not(.c-quantity-change__button-gift), .c-cart-items__remove",
		function () {
			$(".cart-counter__value").removeClass("disabled");
			$(".shop-the-look-popup__container").removeClass("active");
			$("html").removeClass("overflow-hidden");
			setTimeout(function () {
				$("#VariantSelector").val(
					$("#VariantSelector option[selected]").val()
				);
			}, 100);

			const swiper = new Swiper(".popout-cart-swiper", {
				spaceBetween: 16,
				slidesPerView: "auto",
			});
			setTimeout(function () {
				const swiper = new Swiper(".popout-cart-swiper", {
					spaceBetween: 16,
					slidesPerView: "auto",
				});
			}, 1000);
		}
	);

	$(".l-grid").each(function () {
		const grid = $(this);
		const headings = grid.find(".headings .c-menu__title");
		const grandchildContainers = grid.find(".grandchild-container");

		headings.on("mouseenter", function () {
			headings.removeClass("active");
			grandchildContainers.removeClass("active");

			const headingID = $(this).attr("id");

			$(this).addClass("active");
			grid.find(`.grandchild-container[data-id="${headingID}"]`).addClass(
				"active"
			);
		});
	});

	$(".variant-options input").on("change", (event) => {
		const selectedVariantId = event.target.value;
		const selectedVariantImage = event.target.getAttribute(
			"data-product-image-url"
		);
		const selectedVariantPrice =
			event.target.getAttribute("data-product-price");
		const selectedVariantDescription = event.target.getAttribute(
			"data-product-description"
		);

		// Find the parent '.product-item' element
		const productItem = $(event.target).closest(".product-item");

		// Update the price within '.c-price-item' element
		productItem.find(".c-price-item").text(selectedVariantPrice);

		const addToCartButton = productItem.find(".js-klaviyo-add");
		addToCartButton.attr("data-product-price", selectedVariantPrice);
		addToCartButton.attr("data-cart-add", selectedVariantId);
		addToCartButton.attr("data-product-image-url", selectedVariantImage);

		// Update '.c-card__subtitle' within the '.product-item' element
		productItem.find(".c-card__subtitle").text(selectedVariantDescription);

		// Check if the variant has an image and update the product image
		if (selectedVariantImage) {
			// Example code to update the product image if it has an image
			const productImage = productItem.find(".c-card__media-front img");
			productImage.attr("src", selectedVariantImage);
		}
	});

	const product_swipers = (() => {
		$(
			".c-product__carousel--desktop, .product-carousel-section, #shopify-section-cart-related-products"
		).each(function () {
			const swiper = new Swiper(this.querySelector(".swiper-container"), {
				// Optional parameters
				spaceBetween: 16,
				slidesPerView: 1.4,
				// Navigation arrows
				navigation: {
					nextEl: this.querySelector(".c-slider__arrow--next"),
					prevEl: this.querySelector(".c-slider__arrow--prev"),
				},
				breakpoints: {
					600: {
						slidesPerView: 2,
						spaceBetween: 16,
					},
					1024: {
						slidesPerView: 3,
					},
					1200: {
						spaceBetween: 16,
						slidesPerView: 4,
					},
				},
			});
		});
	})();

	// Function to update cart note
	function updateCartNote() {
		var note = $("#cart-gift-message").val(); // Get the value of the cart-gift-message field

		// Update cart note using Shopify default cart.js
		jQuery
			.post("/cart/update.js", { note: note })
			.done(function (data) {
				console.log("Cart note updated successfully");
			})
			.fail(function (jqXHR, textStatus, errorThrown) {
				console.error(
					"Error updating cart note:",
					textStatus,
					errorThrown
				);
			});
	}

	// Call updateCartNote function when the cart-gift-message field is updated
	$(document).on("change", "#cart-gift-message", function () {
		updateCartNote();
	});

	const mainButtonsContainer = $(".main-buttons-container");
	const hiddenButtons = $(".c-popout__buttons.hidden");

	// Function to update the hidden buttons height
	function updateHeight() {
		let currentHeight = mainButtonsContainer.outerHeight();
		hiddenButtons.height(currentHeight);
	}

	// Initial update
	updateHeight();

	$(document).on("change", ".pill-input input", function () {
		var value = $(this).val();
		$(this)
			.parents(".c-gift-message, .c-gift-message-custom")
			.toggleClass("open");
		$(this)
			.parents(".c-gift-message, .c-gift-message-custom")
			.find(".c-gift-message_yes, .c-gift-message_yes-custom")
			.toggleClass("u-visually-hidden");
		updateHeight();

		var attributes = {};
		if (value === "yes") {
			// Set is-this-a-gift attribute to yes
			attributes["is-this-a-gift"] = "yes";
			// Show gift message textarea
			// $('.c-gift-message_yes').show();
		} else {
			// Set is-this-a-gift attribute to no
			attributes["is-this-a-gift"] = "no";
			// Clear gift message textarea
			$("#cart-gift-message").val("");
			// Hide gift message textarea
			// $('.c-gift-message_yes').hide();
		}

		// Update cart attributes using Shopify default cart.js
		jQuery.post("/cart/update.js", { attributes: attributes });
	});

	const glightbox_function = (() => {
		const lightbox = GLightbox({
			touchNavigation: true,
			loop: false,
			autoplayVideos: true,
			zoomable: true,
		});
	})();
}

$(document).on("click", ".results", function () {
	$(".filter-dropdown-active").removeClass("filter-dropdown-active");
});

$(document).on(
	"input",
	"#gift-message, #gift-message-custom, #cart-gift-message",
	function () {
		// Calculate remaining characters
		var maxLength = parseInt($(this).attr("maxlength"));
		var currentLength = $(this).val().length;
		var charactersLeft = maxLength - currentLength;

		// Update the 'characters left' message
		$(this)
			.parent()
			.find("#remaining-characters")
			.text(charactersLeft + " characters left");
	}
);

class PriceRange extends HTMLElement {
	constructor() {
		super();
		this.querySelectorAll("input").forEach((element) =>
			element.addEventListener("change", this.onRangeChange.bind(this))
		);
		this.setMinAndMaxValues();
	}

	onRangeChange(event) {
		this.adjustToValidValues(event.currentTarget);
		this.setMinAndMaxValues();

		// Update the URL with the filter values
		// this.updateURLWithFilters();

		// Trigger a change event on the form to manually submit it
		this.triggerFormChange();
	}

	setMinAndMaxValues() {
		const inputs = this.querySelectorAll("input");
		const minInput = inputs[0];
		const maxInput = inputs[1];
		if (maxInput.value) minInput.setAttribute("max", maxInput.value);
		if (minInput.value) maxInput.setAttribute("min", minInput.value);
		if (minInput.value === "") minInput.setAttribute("min", 0);
		if (maxInput.value === "")
			minInput.setAttribute("max", maxInput.getAttribute("max"));

		// After updating the values, update the URL
	}

	adjustToValidValues(input) {
		const value = Number(input.value);
		const min = Number(input.getAttribute("min"));
		const max = Number(input.getAttribute("max"));

		if (value < min) input.value = min;
		if (value > max) input.value = max;
	}

	// updateURLWithFilters() {
	//   const minInput = this.querySelector('[name="min_price"]');
	//   const maxInput = this.querySelector('[name="max_price"]');

	//   // Get the current URL
	//   const currentURL = new URL(window.location.href);

	//   // Get the search parameters from the URL
	//   const searchParams = new URLSearchParams(currentURL.search);

	//   // Update the filter values in the URL
	//   searchParams.set('filter.v.price.gte', minInput.value);
	//   searchParams.set('filter.v.price.lte', maxInput.value);

	//   // Replace the query string in the URL
	//   location.search = searchParams.toString();
	// }

	triggerFormChange() {
		// Find the form element
		const form = document.getElementById("filter-form");

		// Trigger a change event on the form
		if (form) {
			const event = new Event("change", { bubbles: true });
			form.dispatchEvent(event);
		}
	}
}

customElements.define("price-range", PriceRange);

class PredictiveSearch extends HTMLElement {
	constructor() {
		super();
		this.input = this.querySelector('input[type="search"]');
		this.predictiveSearchResults = this.querySelector("#predictive-search");
		this.input.addEventListener(
			"input",
			this.debounce((event) => {
				this.onChange(event);
			}, 300).bind(this)
		);

		this.input.addEventListener("blur", function () {
			setTimeout(
				function () {
					const predictiveSearch =
						this.parentNode.querySelector("#predictive-search");
					if (predictiveSearch && window.innerWidth > 1024) {
						predictiveSearch.style.display = "none";
						$(predictiveSearch)
							.find(".clear")
							.removeClass("active");
						$("html").removeClass("overflow-hidden");
					}
				}.bind(this),
				400
			);
		});

		this.input.addEventListener("focus", function () {
			if (this.value.trim() !== "") {
				const predictiveSearch =
					this.parentNode.querySelector("#predictive-search");
				if (predictiveSearch) {
					predictiveSearch.style.display = "block";
					$(predictiveSearch).find(".clear").addClass("active");
					$("html").addClass("overflow-hidden");
				}
			}
		});
	}
	onChange() {
		const searchTerm = this.input.value.trim();
		if (!searchTerm.length) {
			this.close();
			return;
		}
		this.getSearchResults(searchTerm);
	}
	getSearchResults(searchTerm) {
		fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)
			.then((response) => {
				if (!response.ok) {
					var error = new Error(response.status);
					this.close();
					throw error;
				}
				return response.text();
			})
			.then((text) => {
				const resultsMarkup = new DOMParser()
					.parseFromString(text, "text/html")
					.querySelector(
						"#shopify-section-predictive-search"
					).innerHTML;
				this.predictiveSearchResults.innerHTML = resultsMarkup;
				this.open();
			})
			.catch((error) => {
				this.close();
				throw error;
			});
	}
	open() {
		this.predictiveSearchResults.style.display = "block";
		$(this.predictiveSearchResults)
			.parent()
			.find(".clear")
			.addClass("active");
		$("html").addClass("overflow-hidden");
	}
	close() {
		this.predictiveSearchResults.style.display = "none";
		$(this.predictiveSearchResults)
			.parent()
			.find(".clear")
			.removeClass("active");
		$("html").removeClass("overflow-hidden");
	}
	debounce(fn, wait) {
		let t;
		return (...args) => {
			clearTimeout(t);
			t = setTimeout(() => fn.apply(this, args), wait);
		};
	}
}
customElements.define("predictive-search", PredictiveSearch);

$(document).on("click", ".clear", function () {
	$(this).parent().find("#Search").val("");
	$(this).removeClass("active");
	$(".predictive-search-container").hide();
	$("html").removeClass("overflow-hidden");
});

$(".clear-filters").on("click", function () {
	// Uncheck all input elements in the form
	$('#filter-form input[type="checkbox"]').prop("checked", false);

	// Set the value of Filter-Price-LTE to the max value
	$("#Filter-Price-LTE").val($("#Filter-Price-LTE").prop("max"));

	// Set the value of Filter-Price-GTE to the min value
	$("#Filter-Price-GTE").val($("#Filter-Price-GTE").prop("min"));

	function formDataToQueryString(formData) {
		const params = new URLSearchParams(formData);
		return params.toString();
	}

	// Example usage:
	formData = new FormData(document.querySelector("#filter-form"));
	const queryString = formDataToQueryString(formData);
	// const apiUrl = `${window.location.href}?${queryString}`;
	if (window.location.href.includes("search")) {
		var apiUrl = `${
			window.location.origin + window.location.pathname
		}/search?${queryString}`;
	} else {
		var apiUrl = `${
			window.location.origin + window.location.pathname
		}?${queryString}`;
	}

	fetch(apiUrl)
		.then((response) => {
			// Check if the response is OK (status code 200)
			if (response.ok) {
				// Parse the response as text
				return response.text();
			} else {
				// Handle errors, for example, by throwing an error
				throw new Error("Failed to fetch HTML");
			}
		})
		.then((html) => {
			// Create a new DOMParser
			const parser = new DOMParser();

			// Parse the HTML content into a DOM
			const doc = parser.parseFromString(html, "text/html");

			// Query the parsed document for the #product-count element
			const productCountElement = doc.querySelector("#product-count");

			if (productCountElement) {
				const productCount = productCountElement.textContent;
				$("#product-count").html(productCount);

				if (productCount == 0) {
					$(".results.c-btn").addClass("disabled");
				} else {
					$(".results.c-btn").removeClass("disabled");
				}
			} else {
				$("#product-count").html("0");
				$(".results.c-btn").removeClass("disabled");
			}
		})
		.catch((error) => {
			console.error("Error:", error);
		});
});

function isElementInViewport(el) {
	var rect = el.getBoundingClientRect();
	return (
		rect.top >= 0 &&
		rect.left >= 0 &&
		rect.bottom <= $(window).height() &&
		rect.right <= $(window).width()
	);
}

if ($(".js-product-form").length) {
	var element = $(".js-product-form");

	function handleScroll() {
		if (isElementInViewport(element[0])) {
			$(".c-product__sticky-bar").addClass("not-active");
		} else {
			$(".c-product__sticky-bar").removeClass("not-active");
		}
	}

	// Attach the scroll event handler to the window
	$(window).on("scroll", handleScroll);
	handleScroll();
}

var isChromium = window.chrome;
var winNav = window.navigator;
var vendorName = winNav.vendor;
var isOpera = typeof window.opr !== "undefined";
var isIEedge = winNav.userAgent.indexOf("Edg") > -1;
var isIOSChrome = winNav.userAgent.match("CriOS");
var isSafari = /^((?!chrome|android).)*safari/i.test(winNav.userAgent);

if (isIOSChrome) {
	$("html").addClass("chrome chrome-ios");
} else if (
	isChromium !== null &&
	typeof isChromium !== "undefined" &&
	vendorName === "Google Inc." &&
	isOpera === false &&
	isIEedge === false
) {
	$("html").addClass("chrome chrome-desktop");
} else if (isSafari) {
	$("html").addClass("chrome chrome-desktop safari");

	$(document).on("mouseleave", ".c-card__header", function () {
		$(this).hide().show(0);
	});
} else {
	// not Google Chrome
}

$(document).on("click", ".c-title__filter-option-title", function () {
	let parent = $(this).parent();
	$(this).toggleClass("active");
	$(parent).find(`.c-filter__option-container`).slideToggle();
});

var lastScroll = $(window).scrollTop();

document.addEventListener("scroll", function (e) {
	if ($("html").hasClass("overflow-hidden") == true) {
		e.preventDefault();
	}

	$(".site-header__currency-form.active").removeClass("active");
	if ($(window).scrollTop() > 200) {
		$("#header").addClass("scrolling");
	} else {
		if ($(window).scrollTop() < 200) {
			$("#header").removeClass("scrolling");
		}
	}

	if (lastScroll > $(window).scrollTop()) {
		$("#header").addClass("up");
	} else {
		$("#header").removeClass("up");
	}
	lastScroll = $(window).scrollTop();
});

$(document).on("click", ".shadow", function () {
	$(".filter-dropdown-active").removeClass("filter-dropdown-active");
	$(".has-shade-minor").removeClass("has-shade-minor");
});

$(document).on("click", ".results.c-btn", function () {
	if (!$(this).hasClass("disabled")) {
		const formData = new FormData(document.querySelector("#filter-form"));
		const queryString = formDataToQueryString(formData);

		let newApiUrl = "";
		if (window.location.href.includes("search")) {
			newApiUrl = `${
				window.location.origin + window.location.pathname
			}/search?${queryString}`;
		} else {
			newApiUrl = `${
				window.location.origin + window.location.pathname
			}?${queryString}`;
		}

		window.location.href = newApiUrl;
	}
});

$(document).on("change", "#filter-form input", function () {
	// Example usage:
	formData = new FormData(document.querySelector("#filter-form"));
	const queryString = formDataToQueryString(formData);
	// const apiUrl = `${window.location.href}?${queryString}`;
	if (window.location.href.includes("search")) {
		var apiUrl = `${
			window.location.origin + window.location.pathname
		}/search?${queryString}`;
	} else {
		var apiUrl = `${
			window.location.origin + window.location.pathname
		}?${queryString}`;
	}

	fetch(apiUrl)
		.then((response) => {
			// Check if the response is OK (status code 200)
			if (response.ok) {
				// Parse the response as text
				return response.text();
			} else {
				// Handle errors, for example, by throwing an error
				throw new Error("Failed to fetch HTML");
			}
		})
		.then((html) => {
			// Create a new DOMParser
			const parser = new DOMParser();

			// Parse the HTML content into a DOM
			const doc = parser.parseFromString(html, "text/html");

			// Query the parsed document for the #product-count element
			const productCountElement = doc.querySelector("#product-count");

			if (productCountElement) {
				const productCount = productCountElement.textContent;
				$("#product-count").html(productCount);

				if (productCount == 0) {
					$(".results.c-btn").addClass("disabled");
				} else {
					$(".results.c-btn").removeClass("disabled");
				}
			} else {
				$("#product-count").html("0");
				$(".results.c-btn").removeClass("disabled");
			}
		})
		.catch((error) => {
			console.error("Error:", error);
		});
});

function updatePagination() {
	let currentNum = $("#Huratips-Pagination .current-items");
	currentNum.text($("#Huratips-Loop .grid__item").length);
	document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
}

$(".site-header__currency-form .current-currency").on("click", function () {
	$(this).parent().parent().toggleClass("active");
	setTimeout(function () {
		$("body").toggleClass("currency-open");
	}, 200);
});

$(document).on("click", ".currency-open", function () {
	$("body").removeClass("currency-open");
	$(".site-header__currency-form").removeClass("active");
});

$(document).on("click", ".js-klaviyo-add", function () {
	let available = $(this).attr("data-available");
	available = parseInt(available, 10) - 1;
	$(this).attr("data-available", available);

	if (available < 1) {
		$(this).parents(".product-item").addClass("out-of-stock");
		$(this).parents(".product-item").find(".c-price").html("Sold out");
	}
});

if ($("#slider-range").length) {
	$(function () {
		$("#slider-range").slider({
			range: true,
			min: 0,
			max: $("#slider-range").attr("max"),
			values: [
				$("#Filter-Price-GTE").val() || 0,
				$("#Filter-Price-LTE").val() || $("#slider-range").attr("max"),
			],
			slide: function (event, ui) {
				$("#Filter-Price-GTE").val(ui.values[0]);
				$("#Filter-Price-GTE").attr("value", ui.values[0]);
				$("#Filter-Price-LTE").val(ui.values[1]);
				$("#Filter-Price-LTE").attr("value", ui.values[1]);

				$("#Filter-Price-LTE").trigger("change");
			},
		});

		$("#Filter-Price-LTE, #Filter-Price-GTE").on("change", function () {
			$("#slider-range").slider({
				range: true,
				min: 0,
				max: $("#slider-range").attr("max"),
				values: [
					$("#Filter-Price-GTE").val() || 0,
					$("#Filter-Price-LTE").val() ||
						$("#slider-range").attr("max"),
				],
				slide: function (event, ui) {
					$("#Filter-Price-GTE").val(ui.values[0]);
					$("#Filter-Price-LTE").val(ui.values[1]);
				},
				stop: function (event, ui) {
					$("#Filter-Price-GTE").attr("value", ui.values[0]);
					$("#Filter-Price-LTE").attr("value", ui.values[1]);
					$("#Filter-Price-LTE").trigger("change");
				},
			});
		});
	});
}

$(document).on("click", ".swym-button.swym-added", function () {
	$(this).removeClass("swym-added");
});

document.addEventListener("DOMContentLoaded", function () {
	mainJs();
});

//custom gift js
document.addEventListener("cartjs:initialized", function () {
	//cookie set and get fucntions that will be used to get the gift id on the user's current session
	function getCookie(name) {
		let matches = document.cookie.match(
			new RegExp(
				"(?:^|; )" +
					name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") +
					"=([^;]*)"
			)
		);
		return matches ? decodeURIComponent(matches[1]) : undefined;
	}

	function setCookie(name, value, days) {
		let expires = "";
		if (days) {
			let date = new Date();
			date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
			expires = "; expires=" + date.toUTCString();
		}
		document.cookie = name + "=" + (value || "") + expires + "; path=/";
	}

	var giftId = getCookie("gift_id");

	if (giftId === undefined) {
		// Cookie not set, set it to 0
		setCookie("gift_id", "0", 365); // Expires in 365 days
		giftId = "0";
	}

	//custom radio button that toggles the innerHTML between choose and added
	$(".product-choice-radio").change(function () {
		var $thisRadio = $(this);
		var $accordionContent = $thisRadio.closest(".accordion-content");
		$(".c-popout-gift-box .next-step").addClass("active");

		// Reset all labels within the same .accordion-content to "Choose"
		$accordionContent.find('label[for^="checkbox-"]').text("CHOOSE");

		// Get the id of the checked radio button within the same .accordion-content
		var checkedRadioId = $thisRadio.attr("id");

		// Change the corresponding label text to "Added" within the same .accordion-content
		$accordionContent
			.find('label[for="' + checkedRadioId + '"]')
			.text("ADDED");
	});

	$(".message-add-input").change(function () {
		var $checkbox = $(this);
		var isChecked = $checkbox.is(":checked");

		isChecked
			? $(this).next("label").html("SAVED")
			: $(this).next("label").html("SAVE");
	});

	// Function to update quantity display and checkbox based on action and limits
	function adjustQuantity($parent, action) {
		var $quantityInput = $parent.find(".c-quantity-change__input-gift");
		var $checkbox = $parent.find(".product-choice-checkbox");
		var maxQuantity = parseInt(
			$quantityInput.attr("data-inventory-quantity")
		);
		var currentQuantity = parseInt($quantityInput.text());
		var newQuantity;

		if (action === "increase") {
			newQuantity =
				currentQuantity < maxQuantity
					? currentQuantity + 1
					: maxQuantity;
			$checkbox.prop("checked", true); // Check the checkbox if quantity is increased
			$checkbox.attr("data-quantity", newQuantity);
		} else {
			newQuantity = Math.max(currentQuantity - 1, 0);
			if (newQuantity === 0) $checkbox.prop("checked", false); // Uncheck if quantity is 0
			$checkbox.attr("data-quantity", newQuantity);
		}

		var isChecked = $checkbox.is(":checked");
		isChecked
			? $($checkbox).next("label").html("ADDED")
			: $($checkbox).next("label").html("CHOOSE");

		// if($('.c-popout-extra-gift .c-cart-items__choose input:checked').length){
		//   $('.add-gift-cart').addClass('active')
		// }else{
		//   $('.add-gift-cart').removeClass('active')
		// }

		$quantityInput.text(newQuantity); // Update the displayed quantity
	}

	// Increase and decrease button functionality within the context of its parent item
	$(".c-quantity-change__button-gift").click(function () {
		var $this = $(this);
		var action = $this.attr("data-action");
		var $parent = $this.closest(".c-cart-items__actions-bottom");

		adjustQuantity($parent, action);
	});

	// Checkbox functionality to set quantity and change the label based on whether the input is checked
	$(".product-choice-checkbox").change(function () {
		var $checkbox = $(this);
		var isChecked = $checkbox.is(":checked");
		var $parent = $checkbox.closest(".c-cart-items__actions-bottom");
		var $quantityInput = $parent.find(".c-quantity-change__input-gift");
		var maxQuantity = parseInt(
			$quantityInput.attr("data-inventory-quantity")
		);

		isChecked
			? $(this).next("label").html("ADDED")
			: $(this).next("label").html("CHOOSE");

		if (isChecked) {
			var quantity = maxQuantity > 0 ? 1 : 0; // Set to 1 if inventory allows, else 0
			$quantityInput.text(quantity);
			$checkbox.attr("data-quantity", 1);
		} else {
			$quantityInput.text(0); // Reset quantity to 0 if checkbox is unchecked
			$checkbox.attr("data-quantity", 0);
		}

		// if($('.c-popout-extra-gift .c-cart-items__choose input:checked').length){
		//   $('.add-gift-cart').addClass('active')
		// }else{
		//   $('.add-gift-cart').removeClass('active')
		// }
	});

	$(".accordion-header").click(function () {
		var isOpen = $(this).parent().hasClass("active");
		$(".accordion-item").removeClass("active");

		$(".accordion-content").slideUp();

		if (!isOpen) {
			$(this).parent().addClass("active");
			$(this).next(".accordion-content").slideDown();
		}
	});

	$(document).on("click", ".start-gift-journey", function (e) {
		e.preventDefault();
		var $this = $(this);
		$(".add-gift-cart")
			.attr("data-product-id", $this.attr("data-item-id"))
			.attr("data-product-title", $this.attr("data-item-title"))
			.attr("data-front", $this.attr("data-front"))
			.attr("data-front-font", $this.attr("data-front-font"))
			.attr("data-back", $this.attr("data-back"))
			.attr("data-back-font", $this.attr("data-back-font"))
			.attr(
				"data-engraving-options-back",
				$this.attr("data-engraving-options-back")
			)
			.attr(
				"data-engraving-options-front",
				$this.attr("data-engraving-options-front")
			)
			.attr("data-select-below", $this.attr("data-select-below"))
			.attr("data-select-below-dot", $this.attr("data-select-below-dot"));
		$(".c-popout-gift-box").addClass("active");
	});

	$(document).on("click", ".c-popout-gift-box .next-step", function (e) {
		e.preventDefault();
		$(".c-popout-extra-gift").addClass("active");
	});

	$(document).on("click", ".c-popout-extra-gift .next-step", function (e) {
		e.preventDefault();
		$(".c-popout-shipping-box").addClass("active");
	});

	$(document).on("click", ".edit-btn", function () {
		$(".c-popout-edit-message textarea")
			.val($(this).attr("data-message"))
			.attr("data-message", $(this).attr("data-message"))
			.attr("data-gift-id", $(this).attr("data-gift-id"))
			.attr("data-gifted", $(this).attr("data-gifted"));
		$(".c-popout-edit-message").addClass("active");
	});

	$(".c-popout-edit-message textarea").on("change", function () {
		if ($(this).val() != $(this).attr("data-message")) {
			$(".save-message").addClass("active");
		} else {
			$(".save-message").removeClass("active");
		}
	});

	function updateCartItemProperties(itemId, giftMessage, giftId) {
		// Get the current cart data
		$.getJSON("/cart.js", function (cart) {
			console.log("Cart Data:", cart); // Debug: Print the cart data to console

			// Find the line item to update
			var lineItem = cart.items.find(function (item) {
				console.log("Checking item:", item); // Debug: Print each item to console
				return item.id == itemId;
			});

			if (lineItem) {
				console.log("Found line item:", lineItem); // Debug: Print the found line item

				// Preserve existing properties and add the new ones
				var properties = lineItem.properties || {};
				properties.gift_message = giftMessage;
				properties.gift_id = giftId;

				// Update the cart with the new data
				$.ajax({
					type: "POST",
					url: "/cart/change.js",
					data: {
						id: lineItem.key,
						quantity: lineItem.quantity,
						properties: properties,
					},
					dataType: "json",
					success: function (cart) {
						console.log("Cart updated:", cart);
						// Optionally, update the UI or show a success message here

						CartJS.getCart();
						$(".save-message, .c-popout-edit-message").removeClass(
							"active"
						);
					},
					error: function (xhr, status, error) {
						console.error("Error updating cart:", error);
						// Optionally, show an error message here
					},
				});
			} else {
				console.error("Product not found in cart");
				// Optionally, show an error message here
			}
		});
	}

	$(document).on("click", ".save-message", function () {
		var $textArea = $(".c-popout-edit-message #gift-message-custom");
		var message = $textArea.val();
		var giftId = $textArea.attr("data-gift-id");
		var productTitle = $textArea.attr("data-gifted"); // Ensure this data attribute is correctly set

		// Example usage: Update the gift_message and gift_id attributes of the product
		updateCartItemProperties(41051382743142, message, giftId);
	});

	$(document).on("click", ".custom-gift-path .c-popout__header", function () {
		$(this).parents(".custom-gift-path").removeClass("active");
	});

	$(".info-btn").click(function () {
		// Retrieve product information from data attributes
		var productImg = $(this).attr("product-img");
		var productTitle = $(this).attr("product-title");
		var productDescription = $(this).attr("product-description");

		// Populate the product information into the pop-out
		$(".c-popout-info .product-img").attr("src", productImg);
		$(".c-popout-info .product-title").text(productTitle);
		$(".c-popout-info .product-desc").text(productDescription);

		// Add the 'active' class to show the pop-out
		setTimeout(() => {
			$(".c-popout.c-popout-info").addClass("active");
		}, 500);
	});

	//abadon gift journey
	$(document).on(
		"click",
		".c-popout-gift-box .c-popout__header",
		function () {
			// Slide up all .accordion-content elements
			$(".c-popout-extra-gift .accordion-content").slideUp();

			// Reset all inputs to be unchecked, and set the corresponding label text to "CHOOSE"
			$(
				'.custom-gift-path input[type="checkbox"], .custom-gift-path input[type="radio"]'
			)
				.prop("checked", false)
				.each(function () {
					$(this).next("label").text("CHOOSE");
				});

			$("#standard-box").next().html("NO");
			$("#luxury-box").next().html("YES");

			$(".c-message__add").find("label").text("SAVE");

			$(".c-quantity-change__input-gift").html("0");
			$(".product-choice-checkbox").attr("data-quantity", "0");

			// Remove the .active class from all elements that have it
			$(
				".c-popout-shipping-box .active, .c-popout-gift-box .active"
			).removeClass("active");
			$(".custom-gift-path").removeClass("active");

			$("#gift-message-custom").val("");
		}
	);

	$(document).on(
		"change",
		".c-popout-shipping-box .product-choice-radio",
		function () {
			$(".add-gift-cart").addClass("active");
		}
	);

	//checking whether the products in the cart have got the Build a gift tag and if so showing the build a gift button and else removing
	window.buildAGiftUpdate = (observer) => {
		$("#popout-cart .c-cart-items__item").each(function () {
			var handle = $(this).attr("data-handle");
			const bannerHTML = `
        <div class="gift-wrap-container" style="display: none" rv-unless="item.properties.giftId">
          <div class="inner-container">
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
              <path d="M25 15V27.5H5V15" stroke="#BF6C6C" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M27.5 8.75H2.5V15H27.5V8.75Z" stroke="#BF6C6C" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M15 27.5V8.75" stroke="#BF6C6C" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M15 8.75H9.375C8.5462 8.75 7.75134 8.42076 7.16529 7.83471C6.57924 7.24866 6.25 6.4538 6.25 5.625C6.25 4.7962 6.57924 4.00134 7.16529 3.41529C7.75134 2.82924 8.5462 2.5 9.375 2.5C13.75 2.5 15 8.75 15 8.75Z" stroke="#BF6C6C" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M15 8.75H20.625C21.4538 8.75 22.2487 8.42076 22.8347 7.83471C23.4208 7.24866 23.75 6.4538 23.75 5.625C23.75 4.7962 23.4208 4.00134 22.8347 3.41529C22.2487 2.82924 21.4538 2.5 20.625 2.5C16.25 2.5 15 8.75 15 8.75Z" stroke="#BF6C6C" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>

            <span>WANT THIS ITEM GIFT WRAPPED?</span>

            <button rv-data-item-id="item.id" 
            rv-data-front="item.properties.Front" 
            rv-data-front-font="item.properties.FrontFont" 
            rv-data-back="item.properties.Back" 
            rv-data-back-font="item.properties.BackFont" 
            rv-data-engraving-options-back="item.properties['Engraving Options on back']"
            rv-data-engraving-options-front="item.properties['Engraving Options on front']"
            rv-data-select-below="item.properties['Select below']"
            rv-data-select-below-dot="item.properties['Select below.']"
            rv-data-item-title="item.title" 
            class="start-gift-journey">Add</button>
          </div>

          <span rv-text="item-properties"></span>
        </div>`;

			fetch(window.Shopify.routes.root + "products/" + handle + ".js")
				.then((response) => response.json())
				.then((product) => {
					if (product.tags.includes("Build A Gift")) {
						// Logic to show the gift-wrap option for this specific item
						if (
							$(this).parent().find(".gift-wrap-container")
								.length > 0
						) {
							$(this)
								.parent()
								.find(".gift-wrap-container")
								.show();
						} else {
							$(this)
								.parent()[0]
								.insertAdjacentHTML("beforeend", bannerHTML);
							$(this)
								.parent()
								.find(".gift-wrap-container")
								.show();
						}
					} else {
						// Remove the gift-wrap option if not applicable
						$(this).parent().find(".gift-wrap-container").remove();
					}
				});
		});
		if (observer) observer.disconnect();

		/*$('#popout-cart .c-cart-items__item').each(function () {
      var handle = $(this).attr('data-handle');
      fetch(window.Shopify.routes.root + 'products/' + handle + '.js')
        .then(response => response.json())
        .then(product => {
          if (product.tags.includes('Build A Gift')) {
            // Logic to show the gift-wrap option for this specific item
            $(this).parent().find('.gift-wrap-container').show();
          } else {
            // Remove the gift-wrap option if not applicable
            $(this).parent().find('.gift-wrap-container').remove();
          }
        });
    });*/
	};

	window.waitBuildAGiftUpdate = () => {
		let observer = new MutationObserver((mutationRecords) => {
			mutationRecords.forEach((mutationRecord) => {
				if (mutationRecord.target.classList.contains("c-cart-items")) {
					[
						...mutationRecord.addedNodes,
						...mutationRecord.removedNodes,
					].forEach((node) => {
						if (node.classList.contains("outer-container")) {
							window.buildAGiftUpdate(observer);
						}
					});
				}
			});
		});

		observer.observe(document.querySelector(`.c-cart-items`), {
			childList: true,
			subtree: true,
			characterDataOldValue: true,
		});
	};

	function addItemsToCartSequentially(items, index = 0) {
		if (index < items.length) {
			var item = items[index];
			$("body").addClass("updatingCart");

			CartJS.addItem(item.id, item.quantity, item.properties, {
				success: function (data, textStatus, jqXHR) {
					console.log("Item added successfully:", data);
					// Call the next item addition after the current one succeeds
					addItemsToCartSequentially(items, index + 1);
				},
				error: function (jqXHR, textStatus, errorThrown) {
					console.error("Error adding item:", errorThrown);
					// Optionally, you could choose to stop the process or continue with the next item
					// Here we choose to continue with the next item
					addItemsToCartSequentially(items, index + 1);
				},
			});
		} else {
			console.log("All items added to cart");
			handleAjaxComplete();
			window.gift_jorney.renderGiftProductCard(
				window.gift_jorney.gift_product.product_handle
			);
			// Optional: perform any action after all items have been added, like updating UI
		}
	}

	//function to add the gift bundle to the cart and re-order the cart into the correct order
	$(document).on("click", ".add-gift-cart", function () {
		var productId = $(this).attr("data-product-id");
		var productTitle = $(this).attr("data-product-title");
		var giftBoxId = $(
			'.product-choice-radio[name="product_choice"]:checked'
		).val();
		var shipBoxId = $(
			'input[id="luxury-box"][name="shipping-box-choice"]:checked'
		).val();
		var giftId = parseInt(getCookie("gift_id") || "0") + 1;
		setCookie("gift_id", giftId, 14);
		var message = $(".c-popout-gift-box #gift-message-custom").val();

		var productsToAdd = [];

		if (message && $("#checkbox-message:checked").length) {
			productsToAdd.push({
				id: 41051382743142,
				quantity: 1,
				properties: {
					giftId: giftId,
					gift_message: message,
					gifted: productTitle,
				},
			});
		}

		productsToAdd.push({
			id: shipBoxId,
			quantity: 1,
			properties: {
				giftId: giftId,
				parentId: giftId,
				gifted: productTitle,
			},
		});

		// Collect data for all selected (checked) products
		$(".product-choice-checkbox:checked").each(function () {
			var id = $(this).val();
			var quantity = $(this).attr("data-quantity");

			productsToAdd.push({
				id: id,
				quantity: quantity,
				properties: {
					giftId: giftId,
					gifted: productTitle,
				},
			});
		});

		productsToAdd.push({
			id: giftBoxId,
			quantity: 1,
			properties: {
				giftId: giftId,
				parentId: giftId,
				gifted: productTitle,
			},
		});

		// productsToAdd.push({
		//   id: productId,
		//   quantity: 1,
		//   properties: {
		//     'giftId': giftId,
		//     'parentId': giftId
		//   }
		// });

		var front = $(this).attr("data-front");
		var frontFont = $(this).attr("data-front-font");
		var back = $(this).attr("data-back");
		var backFont = $(this).attr("data-back-font");
		var engravingOptionsBack = $(this).attr("data-engraving-options-back");
		var engravingOptionsFront = $(this).attr(
			"data-engraving-options-front"
		);
		var selectBelow = $(this).attr("data-select-below");
		var selectBelowDot = $(this).attr("data-select-below-dot");

		var productProperties = {
			giftId: giftId,
			parentId: giftId,
		};

		if (front) productProperties["Front"] = front;
		if (frontFont) productProperties["FrontFont"] = frontFont;
		if (back) productProperties["Back"] = back;
		if (backFont) productProperties["BackFont"] = backFont;
		if (engravingOptionsBack)
			productProperties["Engraving Options on back"] =
				engravingOptionsBack;
		if (engravingOptionsFront)
			productProperties["Engraving Options on front"] =
				engravingOptionsFront;
		if (selectBelow) productProperties["Select below"] = selectBelow;
		if (selectBelowDot) productProperties["Select below."] = selectBelowDot;

		productsToAdd.push({
			id: productId,
			quantity: 1,
			properties: productProperties,
		});

		console.log(productsToAdd);

		CartJS.getCart({
			success: function (cart) {
				console.log("Original Cart:", cart.items); // Log original cart items for debugging

				var quantityAdjusted = false; // Flag to indicate if quantity decrement has been done
				var newCartItems = cart.items.reduce((acc, item) => {
					// Check if the item matches the productId
					if (item.id.toString() === productId.toString()) {
						if (
							!item.properties ||
							(item.properties &&
								Object.keys(item.properties).length == 0)
						) {
							if (!quantityAdjusted) {
								// Check if we haven't already adjusted the quantity
								if (item.quantity > 1) {
									// Decrease the quantity by 1 if more than one
									acc.push({
										...item,
										quantity: item.quantity - 1,
									});
								}
								// If quantity is 1, do not push the item (effectively removing it)
								quantityAdjusted = true; // Mark that we have adjusted the quantity
							} else {
								// If already adjusted or item has different properties, push as is
								acc.push(item);
							}
						} else if (
							!item.properties.giftId &&
							(item.properties.Front ||
								item.properties.FrontFont ||
								item.properties.Back ||
								item.properties.BackFont ||
								item.properties["Engraving Options on back"] ||
								item.properties["Engraving Options on front"] ||
								item.properties["Select below"] ||
								item.properties["Select below."])
						) {
							if (!quantityAdjusted) {
								if (item.quantity > 1) {
									acc.push({
										...item,
										quantity: item.quantity - 1,
									});
								}
								// If quantity is 1, do not push the item (effectively removing it)
								quantityAdjusted = true;
							} else {
								acc.push(item);
							}
						} else {
							// Push the item if it has giftId or other properties
							acc.push(item);
						}
					} else {
						// Push all other items as they are
						acc.push(item);
					}

					return acc;
				}, []);

				newCartItems.reverse();

				// Clear the existing items from the cart
				CartJS.clear({
					success: function () {
						$("body").addClass("updatingCart");
						// Once the cart is empty, add the new list of items
						addItemsToCartSequentially(
							newCartItems.concat(productsToAdd)
						);
					},
					error: function (error) {
						console.error("Error clearing cart:", error);
					},
				});
			},
			error: function () {
				console.error("Error retrieving cart.");
			},
		});

		// Slide up all .accordion-content elements
		$(".c-popout-extra-gift .accordion-content").slideUp();

		// Reset all inputs to be unchecked, and set the corresponding label text to "CHOOSE"
		$(
			'.custom-gift-path input[type="checkbox"], .custom-gift-path input[type="radio"]:not([name="shipping-box-choice"])'
		)
			.prop("checked", false)
			.each(function () {
				$(this).next("label").text("CHOOSE");
			});

		$(".c-message__add").find("label").text("SAVE");
		$("#standard-box").prop("checked", true);

		$(".c-quantity-change__input-gift").html("0");
		$(".product-choice-checkbox").attr("data-quantity", "0");

		// Remove the .active class from all elements that have it
		$(
			".c-popout-shipping-box .active, .c-popout-gift-box .active"
		).removeClass("active");

		$(".custom-gift-path").removeClass("active");
		$("#gift-message-custom").val("");
	});

	$(document).on("click", ".c-shade", function () {
		// Slide up all .accordion-content elements
		$(".c-popout-extra-gift .accordion-content").slideUp();

		// Reset all inputs to be unchecked, and set the corresponding label text to "CHOOSE"
		$(
			'.custom-gift-path input[type="checkbox"], .custom-gift-path input[type="radio"]'
		)
			.prop("checked", false)
			.each(function () {
				$(this).next("label").text("CHOOSE");
			});

		$(".c-message__add").find("label").text("SAVE");

		$(".c-quantity-change__input-gift").html("0");
		$(".product-choice-checkbox").attr("data-quantity", "0");

		// Remove the .active class from all elements that have it
		$(
			".c-popout-shipping-box .active, .c-popout-gift-box .active"
		).removeClass("active");
		$(".custom-gift-path").removeClass("active");

		$("#gift-message-custom").val("");
	});

	//loop through each item to see if it's a gift element or not
	$(".outer-container").each(function () {
		var $cartItem = $(this); // Current cart item

		if (!$(this).attr("data-gift-id")) {
			// Find the minus button within this cart item and add the 'not-gift-product' class
			$cartItem
				.find(".c-quantity-change__button.minus")
				.addClass("not-gift-product");
		}
	});

	var prevGiftId = null;

	// Iterate over each .outer-container to see if product needs a border above it or not
	$(".outer-container[data-gift-id]").each(function () {
		var currentGiftId = $(this).attr("data-gift-id");
		var $count = 0;

		// Check if the current data-gift-id matches the previous one
		if (currentGiftId === prevGiftId) {
			// Add .no-border class to the current .outer-container
			$count++;
			$(this).attr("data-count", $count);
			$(this).addClass("no-border");
		} else {
			$count = 0;
			$(this).removeClass("no-border");
			$(this).attr("data-count", $count);
		}

		// Update prevGiftId for the next iteration
		prevGiftId = currentGiftId;
	});

	// Object to track the last item of each gift ID type
	var lastItems = {};

	// Iterate over each item and store the last one of each type
	$(".outer-container").each(function () {
		var giftId = $(this).attr("data-gift-id");
		// Update the last item for each giftId encountered
		lastItems[giftId] = $(this);
	});

	// Iterate over the stored last items
	$.each(lastItems, function (giftId, lastItemElem) {
		// Find all items with the same giftId that are not the last item
		$('.outer-container[data-gift-id="' + giftId + '"]')
			.not(lastItemElem)
			.each(function () {
				// Remove the .c-gift-message from these items
				$(this)
					.find(".c-gift-message, .c-gift-message-custom")
					.remove();
			});
	});

	// Function to remove items with a specific giftId
	function removeItemsWithGiftId(giftIdToRemove) {
		$("body").addClass("updatingCart");

		CartJS.getCart({
			success: function (cart) {
				// Filter to keep items that do not match the specified giftId
				var itemsToKeep = cart.items.filter(function (item) {
					return !(
						item.properties &&
						item.properties.giftId == giftIdToRemove
					);
				});

				// itemsToKeep.reverse(

				// Clear the cart first
				CartJS.clear({
					success: function () {
						$("body").addClass("updatingCart");
						console.log("Cart cleared successfully.");

						// Function to add items back to the cart
						function addItemsBack(items) {
							if (items.length === 0) {
								handleAjaxComplete();
								return;
							}

							var item = items.pop(); // Remove the last item to add it back

							CartJS.addItem(
								item.id,
								item.quantity,
								item.properties,
								{
									success: function () {
										addItemsBack(items);
									},
									error: function (error) {
										console.error(
											"Error adding item back to cart:",
											error
										);
									},
								}
							);
						}

						addItemsBack(itemsToKeep.slice());
					},
					error: function () {
						console.error("Error clearing the cart.");
					},
				});
			},
			error: function () {
				console.error("Error fetching cart details.");
			},
		});
	}

	function updateAndRemoveItemsForGiftId(giftIdToRemove) {
		CartJS.getCart({
			success: function (cart) {
				// Filter to keep items that do not match the specified giftId or have gifted as true
				var itemsToKeep = cart.items.filter(function (item) {
					return !(
						item.properties &&
						item.properties.giftId == giftIdToRemove
					);
				});

				// Prepare items to re-add by removing properties if they have the giftId but not the gifted property
				var itemsToModify = cart.items
					.filter(function (item) {
						return (
							item.properties &&
							item.properties.giftId == giftIdToRemove &&
							!item.properties.gifted
						);
					})
					.map(function (item) {
						return {
							id: item.id,
							quantity: item.quantity,
							properties: {}, // Reset properties
						};
					});

				$("body").addClass("updatingCart");

				// Clear the cart
				CartJS.clear({
					success: function () {
						$("body").addClass("updatingCart");

						console.log("Cart cleared successfully.");

						// Re-add items with their properties intact
						itemsToKeep.forEach(function (item) {
							CartJS.addItem(
								item.id,
								item.quantity,
								item.properties,
								{
									success: function () {
										console.log(
											"Item added back to cart:",
											item.id
										);
									},
									error: function () {
										console.error(
											"Error adding item back to cart:",
											item.id
										);
									},
								}
							);
						});

						// Re-add modified items with properties removed
						itemsToModify.forEach(function (item) {
							CartJS.addItem(
								item.id,
								item.quantity,
								item.properties,
								{
									success: function () {
										console.log(
											"Item added back to cart with properties removed:",
											item.id
										);
										handleAjaxComplete();
									},
									error: function () {
										console.error(
											"Error adding item back to cart:",
											item.id
										);
									},
								}
							);
						});
					},
					error: function () {
						console.error("Error clearing the cart.");
					},
				});
			},
			error: function () {
				console.error("Error fetching cart details.");
			},
		});
	}

	// Trigger to remove items with a specific giftId when a remove button is clicked
	// Adjust the selector based on your actual button for removing an item or initiating this process.
	$(document).on(
		"click",
		".js-cart-remove-custom, .c-quantity-change__button.minus",
		function () {
			var giftId = $(this)
				.closest(".outer-container")
				.attr("data-gift-id");
			var dataCount = $(this)
				.closest(".outer-container")
				.attr("data-count");
			var parentId = $(this)
				.closest(".outer-container")
				.attr("data-parent-id");

			if (dataCount == 0) {
				if (giftId) {
					removeItemsWithGiftId(giftId);
				}
			} else if (dataCount == 1) {
				if (giftId && parentId) {
					setTimeout(() => {
						updateAndRemoveItemsForGiftId(giftId);
					}, 500);
				}
			}
		}
	);
});

// });
let isHandlingAjaxComplete = false;
let isUpdatingCart = false;

function handleAjaxComplete() {
	if (isHandlingAjaxComplete || isUpdatingCart) return; // Prevent recursion
	isHandlingAjaxComplete = true;

	setTimeout(() => {
		// Loop through each item to see if it's a gift element or not
		$(".outer-container").each(function () {
			var $cartItem = $(this); // Current cart item

			if (!$(this).attr("data-gift-id")) {
				// Find the minus button within this cart item and add the 'not-gift-product' class
				$cartItem
					.find(".c-quantity-change__button.minus")
					.addClass("not-gift-product");
			}
		});

		// Object to track the last item of each gift ID type
		var lastItems = {};

		// Iterate over each item and store the last one of each type
		$(".outer-container").each(function () {
			var giftId = $(this).attr("data-gift-id");
			// Update the last item for each giftId encountered
			lastItems[giftId] = $(this);
		});

		// Iterate over the stored last items
		$.each(lastItems, function (giftId, lastItemElem) {
			// Find all items with the same giftId that are not the last item
			$('.outer-container[data-gift-id="' + giftId + '"]')
				.not(lastItemElem)
				.each(function () {
					// Remove the .c-gift-message from these items
					$(this)
						.find(".c-gift-message, .c-gift-message-custom")
						.remove();
				});
		});

		/*$('#popout-cart .c-cart-items__item').each(function () {
      var handle = $(this).attr('data-handle');

      fetch(window.Shopify.routes.root + 'products/' + handle + '.js')
        .then(response => response.json())
        .then(product => {
          if (product.tags.includes('Build A Gift')) {
            // Logic to show the gift-wrap option for this specific item
            $(this).parent().find('.gift-wrap-container').show();
          } else {
            // Remove the gift-wrap option if not applicable
            $(this).parent().find('.gift-wrap-container').remove();
          }
        });
    });*/

		var prevGiftId = null;

		// Iterate over each .outer-container
		$(".outer-container[data-gift-id]").each(function () {
			var currentGiftId = $(this).attr("data-gift-id");
			var $count = 0;

			// Check if the current data-gift-id matches the previous one
			if (currentGiftId === prevGiftId) {
				// Add .no-border class to the current .outer-container
				$count++;
				$(this).attr("data-count", $count);
				$(this).addClass("no-border");
			} else {
				$count = 0;
				$(this).removeClass("no-border");
				$(this).attr("data-count", $count);
			}

			// Update prevGiftId for the next iteration
			prevGiftId = currentGiftId;
		});

		isHandlingAjaxComplete = false;
	}, 1000);

	updateDisplayedQuantities();
	window.gift_jorney.renderGiftProductCard(
		window.gift_jorney.gift_product.product_handle
	);
	window.addEventListener("pplrAddToCartCompleted", function (e) {
		CartJS.getCart({
			success: function () {
				$("body")
					.addClass("popout-cart-active")
					.addClass("has-shade-2x");
			},
		});
	});
}

function updateDisplayedQuantities() {
	if (!isUpdatingCart) {
		isUpdatingCart = true; // Set the flag when starting the update
		$("body").addClass("updatingCart");

		setTimeout(() => {
			$.ajax({
				url: "/cart.js",
				type: "GET",
				dataType: "json",
				success: function (cart) {
					// Iterate through each item in the cart
					cart.items.forEach(function (item, index) {
						// Find the nth child of .outer-container.pplr_cart_row
						var $outerContainer = $(
							".outer-container.pplr_cart_row"
						).eq(index);

						// Find the .start-gift-journey button within that element
						var $startGiftJourneyButton = $outerContainer.find(
							".start-gift-journey"
						);

						// Update the quantity display
						$outerContainer
							.find(".item-quantity-display")
							.text(item.quantity);

						// Check if the properties exist and set them on the button
						if (item.properties) {
							if (item.properties["Engraving Options on back"]) {
								$startGiftJourneyButton.attr(
									"data-engraving-options-back",
									item.properties["Engraving Options on back"]
								);
							}
							if (item.properties["Engraving Options on front"]) {
								$startGiftJourneyButton.attr(
									"data-engraving-options-front",
									item.properties[
										"Engraving Options on front"
									]
								);
							}
							if (item.properties["Select below"]) {
								$startGiftJourneyButton.attr(
									"data-select-below",
									item.properties["Select below"]
								);
							}
							if (item.properties["Select below."]) {
								$startGiftJourneyButton.attr(
									"data-select-below-dot",
									item.properties["Select below."]
								);
							}
						}
					});
				},
				error: function () {
					console.error("Failed to fetch cart data");
				},
				complete: function () {
					setTimeout(() => {
						isUpdatingCart = false; // Reset the flag after the update is complete
						$("body").removeClass("updatingCart");
					}, 1000);
				},
			});
		}, 1000);
	}
}

document.addEventListener("cartjs:initialized", function () {
	document.addEventListener("click", function (event) {
		if (event.target.closest(".complimentary-product")) {
			const clickedElement = event.target.closest(
				".complimentary-product"
			);
			if (clickedElement.classList.contains("active")) {
				clickedElement.classList.remove("active");
			} else {
				document
					.querySelectorAll(".complimentary-product")
					.forEach(function (element) {
						element.classList.remove("active");
					});
				clickedElement.classList.add("active");
			}

			// Show or hide .complimentary-pick based on the presence of the active class
			if (document.querySelector(".complimentary-product.active")) {
				document.querySelector(".complimentary-pick").style.display =
					"block";
				const activeElement = document.querySelector(
					".complimentary-product.active"
				);

				console.log(activeElement.getAttribute("data-title"));

				document.querySelector(
					".complimentary-pick-title"
				).textContent = activeElement.getAttribute("data-title");
				document.querySelector(
					".complimentary-pick-price"
				).textContent = activeElement.getAttribute("data-price");
			} else {
				document.querySelector(".complimentary-pick").style.display =
					"none";
			}
		}
	});

	document.querySelector("#AddToCart").addEventListener("click", function () {
		console.log("#AddToCart");
		const activeProduct = document.querySelector(
			".complimentary-product.active"
		);
		if (activeProduct) {
			const productId = activeProduct.getAttribute("data-id");
			console.log("Active Product ID:", productId);
			// You can now use the productId as needed
			CartJS.addItem(productId, 1, {});
			document
				.querySelector(".complimentary-product.active")
				.classList.remove("active");

			document.querySelector(".complimentary-pick").style.display =
				"none";
		} else {
			console.log("No active product selected");
		}
	});
});

$(document).ready(function () {
	// Bind to the global ajaxComplete event, which is triggered after any AJAX request completes
	$(document).ajaxComplete(function (event, xhr, settings) {
		if (settings.url.includes("/cart")) {
			handleAjaxComplete();
			updateDisplayedQuantities();
		}
	});

	handleAjaxComplete();
});

window.addEventListener("pplrAddToCartCompleted", function (e) {
	CartJS.getCart({
		success: function () {
			$("body").addClass("popout-cart-active").addClass("has-shade-2x");
		},
	});
});

// js/sections/product-recommendations.js
var ProductRecommendations = class extends HTMLElement {
	constructor() {
		super();
		this._isLoaded = false;
	}
	connectedCallback() {
		this._loadRecommendations();
	}
	async _loadRecommendations() {
		if (this._isLoaded) {
			return;
		}
		this._isLoaded = true;

		const section = this.closest(".shopify-section"),
			intent = "complementary",
			url = `${
				Shopify.routes.root
			}recommendations/products?product_id=${this.getAttribute(
				"product"
			)}&limit=${
				this.getAttribute("limit") || 4
			}&section_id=${section.id.replace(
				"shopify-section-",
				""
			)}&intent=${intent}`;

		const response = await fetch(url, { priority: "low" });

		const tempDiv = new DOMParser().parseFromString(
				await response.text(),
				"text/html"
			),
			productRecommendationsElement = tempDiv.querySelector(
				"product-recommendations"
			);

		if (productRecommendationsElement.childElementCount > 0) {
			this.replaceChildren(
				...document.importNode(productRecommendationsElement, true)
					.childNodes
			);

			const swiper = new Swiper(".complimentary-swiper", {
				// Optional parameters,
				slidesPerView: 3.1,
				spaceBetween: 16,
				centeredSlidesBounds: true,
				// Navigation arrows
				navigation: {
					nextEl: this.querySelector(".c-slider__arrow--next"),
					prevEl: this.querySelector(".c-slider__arrow--prev"),
				},
				breakpoints: {
					768: {
						slidesPerView: 3.5,
						spaceBetween: 16,
					},
					1100: {
						slidesPerView: 4.5,
						spaceBetween: 16,
					},
				},
			});
		} else {
			if (intent === "related") {
				section.remove();
			} else {
				this.remove();
			}
		}
	}
};
if (!window.customElements.get("product-recommendations")) {
	window.customElements.define(
		"product-recommendations",
		ProductRecommendations
	);
}

document.querySelectorAll(".blog-products-swiper").forEach((element) => {
	const swiper = new Swiper(element, {
		slidesPerView: 1.6,
		spaceBetween: 12,
		breakpoints: {
			480: {
				slidesPerView: 2.1,
				spaceBetween: 12,
			},
			800: {
				slidesPerView: 3,
				spaceBetween: 12,
			},
		},
	});
});
document
	.querySelectorAll(".blog-products-related-swiper")
	.forEach((element) => {
		const swiper = new Swiper(element, {
			slidesPerView: 1.6,
			spaceBetween: 12,
			breakpoints: {
				480: {
					slidesPerView: 2.1,
					spaceBetween: 12,
				},
				800: {
					slidesPerView: 3.1,
					spaceBetween: 12,
				},
				992: {
					slidesPerView: 4,
					spaceBetween: 16,
				},
			},
		});
	});
